import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from "react-helmet";
import { useCookies } from 'react-cookie';
import { useHistory, Link } from "react-router-dom";

function WarHistory(props) {
	let history = useHistory();
    const { state } = props.location
	const [kingdomStats] = useState(state[0]);
    console.log(kingdomStats);
    const [cookies] = useCookies(['user']);
	const user_id = cookies.user_id;
	const token = cookies.token;
    const [html, setHtml] = useState('');
    const startDate = useRef(null);
    const endDate = useRef(null);
    const [e, sete] = useState('');
    const [s, sets] = useState('');
    useEffect(() => {
		getWarHistory();
	}, []);

    const getWarHistory = async () => {
        let d = new Date();
		let startMonth = d.getMonth();
        let endMonth = d.getMonth()+1;
		let day = d.getDate();
		// let startD =  d.getFullYear() + '-' + ((''+startMonth).length<2 ? '0' : '') + startMonth + '-' + ((''+day).length<2 ? '0' : '') + day ;
        let month = d.getMonth()
        let startD = d.getFullYear()+"-02-01";
        if(month == 0) {
            startD = (d.getFullYear() - 1)+"-02-01";
        }
        let endD =  d.getFullYear() + '-' + ((''+endMonth).length<2 ? '0' : '') + endMonth + '-' + ((''+day).length<2 ? '0' : '') + day ;
        if(startDate.current.value !== "") {
            startD = startDate.current.value;
        }
        if(endDate.current.value !== ""){
            endD = endDate.current.value;
        }
        startDate.current.value = startD;
        console.log(startD);
        sets(startD);
        endDate.current.value = endD;
        console.log(endD);
        sete(endD);
        const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json','token':token,'userId':user_id  },
			body: JSON.stringify({kingdom_id:kingdomStats.k_id,start_date:startD, end_date:endD}),
		};
		const response	 = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'bkb-war-data', requestOptions);
		const data = await response.json();
        console.log(data);
        const items = [];
        for (const [index, value] of data.wars.entries()) {
            let winLoseId = "won";
            let winLoseImage1 = <img src={require("./../images/won-icon.png").default} alt="win"/>;
            let winLoseImage2 = <img src={require("./../images/thumb.png").default} alt="thunbup" className="thumb" />;
            let res = <p className="mb-1 wons">You {value.result}</p>;
            if(value.result === "Lost"){
                winLoseId = "lost";
                winLoseImage1 = <img src={require("./../images/lost-icon.png").default} alt="lost"/>;
                winLoseImage2 = <img src={require("./../images/down-thumb.png").default} alt="thumbdown" className="thumb" />;
                res = <p className="mb-1 losts">You {value.result}</p>;
            }
            items.push(
                <Link to={{
                    pathname:"/war-score",
                    state: [kingdomStats, value.war_id]
                }} className="card mt-2" key={index}>

                <div >
                    <div className="card-body">
                        <div className="row" id={winLoseId}>
                            <div className="d-inline-block mx-3 my-auto won">
                                {winLoseImage1}
                                {winLoseImage2}
                            </div>
                            <div className="d-inline-block mx-3">
                                <p id="lll" className="mb-1 kingdom">V/s {value.opponent}</p>
                                {res}
                                <p className="mb-1 date">{value.date}</p>
                            </div>
                        </div>
                    </div>
                </div>
                </Link>
            );
        }
        if(data.wars.length === 0){
            items.push(<p style={{textAlign:`center`, color:`red  `}} key="1111">No Wars Found.</p>);
        }
        setHtml(items);
    }

    return (
<>
	<Helmet link={
		[{"rel": "stylesheet", "href": 'css/history-of-war.css'},
        {"rel": "stylesheet", "href": 'css/jquerysctipttop.css'},
        {"rel": "stylesheet", "href": 'css/bootstrap-side-modals.css'},
        {"rel": "stylesheet", "href": 'css/gijgo.min.css'}]
	}/>
    <Helmet>
        <script src="/js/date.js" type="text/javascript" />
    </Helmet>
    <div className="row no-gutters">
      <div className="application bg-grey">
        {/* <div style=
            {{
                backgroundImage: `url(${kingdomStats.kd_image}), linear-gradient(
            144deg, #997A5C, #6D6264, rgba(0, 0, 0, 0.25))`,
                backgroundBlendMode: `multiply`,
                backgroundSize: `100% 100%`,
                backgroundPosition: `left`,
                borderBottomLeftRadius: `8px`,
                borderBottomRightRadius: `8px`,
                height: `134px`,
                backgroundRepeat: `no-repeat`
            }}
        > */}
        <div className="bg-gradient1">

        <div className="appHeader bg-transparent text-light position-relative">
          <div className="left">
              <a className="headerButton goBack"  onClick={() => history.goBack()}>
                <img src={require("./../images/back.png").default} alt="back" className="img-fluid" />
              </a>
          </div>
          <div className="right">
            {/* <Link to="/faq" className="headerButton">
                <img src={require("./../images/faq1.png").default} alt="faq" className="img-fluid" />
            </Link> */}
          </div>
        </div>
        
        <div className="section mt-2 kingdom">
           
            <div className="kingdom-left">
                <h2>History</h2>
            </div>
        </div>

    </div>  
      
        <div className="section result">
            <div className="mt-3 mx-auto">
                <p className="d-inline-block">PAST RESULTS</p>
                <img src={require("./../images/Calendar-icon.png").default} alt="faq"  className="d-inline-block ml-auto float-right" data-toggle="modal" data-target="#bottom_modal" />
            </div>
        </div>
      
        <div className="section" style={{
        overflowY: 'scroll',
        overflowX: `hidden`,
        height: `calc(100vh - 200px)` ,
        width: `100%`}}>
            {html}
        </div>

      </div>
        <div className="modal bottom fade" id="bottom_modal" tabIndex="-1" role="dialog" aria-labelledby="bottom_modal">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header border-0 px-26">
                        <h5 className="modal-title" id="dssd">Select Date</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{opacity:`1`}}>
                            <img alt="" src={require("./../images/close.png").default} className="img-fluid" />
                        </button>
                    </div>
                    <div className="modal-body px-34">
                        <div className="row justify-content-between">
                            <div className="col-5 col-md-5 col-lg-5">
                                <div className="form-label-group">
                                    <input type="text" readOnly={true} className="form-control start-date" id="label-name" ref={startDate} value={s}/>
                                    <label>Start Date</label>
                                </div>
                            </div>
                            <div className="col-5 col-md-5 col-lg-5">
                                <div className="form-label-group">
                                    <input type="text" readOnly={true} className="form-control end-date" id="label-name" ref={endDate} value={e}/>
                                    <label>End Date</label>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center my-3">
                            <div className="col-8 col-md-8 col-lg-8">
                                <a className="btn btn-apply btn-block"  data-dismiss="modal" aria-label="Close" onClick={getWarHistory} >Apply</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="bg"></div>
    </div>
</>
    );
}

export default WarHistory;
